import { Form, Select } from "antd";
import useMasterContext from "Context/MasterContext";
import React from "react";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 0px !important;
`;
const DRSFooterFilter = () => {
  const { masters } = useMasterContext();
  const { subjects, streams } = masters || {};
  const { screen } = useWindowSize();
  const isDestop = ["xxl", "xl", "lg"].includes(screen);
  return (
    <div className={isDestop ? "d-flex gap-3" : "d-flex gap-3"}>
      <StyledFormItem
        name="streamId"
        label={!isDestop ? "" : "Stream"}
        style={{
          width: "150px",
        }}
      >
        <Select
          placeholder="Select Stream"
          allowClear
          options={streams}
        ></Select>
      </StyledFormItem>

      {/* Subject */}
      <StyledFormItem name="subjectId" label={!isDestop ? "" : "Subject"}>
        <Select
          placeholder="Select Subject"
          allowClear
          options={subjects}
        ></Select>
      </StyledFormItem>
    </div>
  );
};

export default DRSFooterFilter;
